import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import Modal from 'components/Modal'
import LinkButton, { LINK_BUTTON_THEMES } from 'components/LinkButton'
import Link, { LINK_BEHAVIORS } from 'components/Link'

import './PageSubscription.scss'

class PageSubscription extends React.Component {
    static propTypes = {
        description: PropTypes.string.isRequired,
        labels: PropTypes.shape({
            cancel: PropTypes.string.isRequired,
            close: PropTypes.string.isRequired,
            goToMyPage: PropTypes.string.isRequired,
            subscribe: PropTypes.string.isRequired
        }).isRequired,
        isSubscribing: PropTypes.bool.isRequired,
        url: PropTypes.string.isRequired,
        className: PropTypes.string
    }

    static defaultProps = {
        labels: {}
    }

    state = {
        open: false
    }

    _toggleOpen = () => this.setState({ open: !this.state.open })
    _closeModal = () => {
        const close = document.querySelector('[data-modal="close"]')

        if(close && close.click) {
            close.click()
        } else {
            this._toggleOpen()
        }
    }

    render() {
        const {
            description,
            labels,
            url,
            className
        } = this.props

        const {
            open
        } = this.state

        return (
            <div>
                <LinkButton 
                    text={labels.subscribe}
                    theme={LINK_BUTTON_THEMES.dark}
                    className={cn("page-subscription", className)}
                    onClick={this._toggleOpen}
                />
                {open && (
                    <Modal 
                        hasImage={true} 
                        labels={labels}
                        onClose={this._toggleOpen}
                    >
                        <div className="page-subscription__image" />
                        <div className="page-subscription__content">
                            <div 
                                className="wysiwyg" 
                                dangerouslySetInnerHTML={{__html: description}}
                            />
                            <div className={cn("page-subscription__actions")}>
                                <LinkButton 
                                    url={url}
                                    text={labels.goToMyPage}
                                    theme={LINK_BUTTON_THEMES.dark}
                                />
                                <Link
                                    text={labels.cancel}
                                    onClick={this._closeModal}
                                    behavior={LINK_BEHAVIORS.text}
                                    className="page-subscription__cancel"
                                />
                            </div>
                        </div>
                    </Modal>
                )}
            </div>
        )
    }
}

export default PageSubscription
